import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Home, Store, Mail } from 'lucide-react';

export const RestaurantSuccess = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-50 flex items-center justify-center" data-testid="restaurant-success-page">
      <div className="max-w-lg mx-auto px-4">
        <Card className="p-8 md:p-12 text-center">
          <div className="bg-green-100 text-[#2D8B2E] p-6 rounded-full inline-block mb-6">
            <CheckCircle className="w-16 h-16" />
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Application Submitted!
          </h1>
          
          <p className="text-gray-600 mb-8">
            Thank you for partnering with Fudco! Our team will review your application and contact you within 24-48 hours.
          </p>

          <div className="bg-green-50 p-6 rounded-2xl mb-8">
            <h3 className="font-semibold text-gray-900 mb-3">What's Next?</h3>
            <ul className="text-left text-sm text-gray-600 space-y-2">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-[#2D8B2E] mt-0.5 flex-shrink-0" />
                <span>Our team will verify your details</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-[#2D8B2E] mt-0.5 flex-shrink-0" />
                <span>We'll contact you for onboarding process</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-[#2D8B2E] mt-0.5 flex-shrink-0" />
                <span>Complete KYC and start receiving orders</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/" className="flex-1">
              <Button variant="outline" className="w-full h-12 rounded-full" data-testid="go-home-btn">
                <Home className="w-4 h-4 mr-2" />
                Go Home
              </Button>
            </Link>
            <Link to="/restaurant-partner" className="flex-1">
              <Button className="w-full h-12 bg-[#2D8B2E] hover:bg-[#236c24] text-white rounded-full" data-testid="add-another-btn">
                <Store className="w-4 h-4 mr-2" />
                Add Another
              </Button>
            </Link>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-2">Questions? Contact us</p>
            <a href="mailto:service@fudco.in" className="flex items-center justify-center gap-2 text-[#2D8B2E] font-medium">
              <Mail className="w-4 h-4" />
              service@fudco.in
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
};
